export default class WorkingEnvironmentPageEntity {

  constructor (
    id,
    title,
    ingress,
    text,
    sections,
    image,
    letterbutton,
    letterbox
  ) {
    this.id = id;
    this.title = title;
    this.ingress = ingress;
    this.text = text;
    this.sections = sections;
    this.image = image;
    this.letterbutton = letterbutton;
    this.letterbox = letterbox;
  }

}



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/working-environment-page/working-environment-page-entity.js
 **/